import Faye from 'faye'
import jQuery from 'jquery'

export default {
    startFayeClient({ commit, state }) {
        if(state.faye.client) state.faye.client.disconnect();
        
        let fayeClient = new Faye.Client(state.faye.url + '/faye', { retry: 5 })
        commit('updateFayeClient', fayeClient)

        fayeClient.subscribe( state.faye.channel, result => {
            setTimeout(() => commit('updateFayeResult', result), 10)
        })
    },
    exibeMensagemCarregamento ({ dispatch }, payload) {
        dispatch('Loading/updateLoading', {
            show: true,
            message: payload
        })
    },
    closeLoading ({ dispatch }, timerToClose = 0) {
        setTimeout(() => {
            dispatch('Loading/updateLoading', {
                show: false
            })
        }, timerToClose)
    },
    scrollToTop(context, payload){
        jQuery("html, body").animate({
            scrollTop: payload
        }, "slow")
    },
    googleAnalytics(context, payload) {
        try {
            ga('send', 'pageview', payload)
        } catch(e) {}
    }
}



// WEBPACK FOOTER //
// ./src/shared/helpers/vuex/actions.js